import { BASE_TIPPY_DIRECTIONS as o, TIPPY_STICKY_VALUES as t } from "../popover/tippy-utils.js";
const I = [
  ...o
], T = 300, _ = {
  hover: "d-tooltip--hover",
  show: "d-tooltip--show",
  inverted: "d-tooltip--inverted",
  hide: "d-tooltip--hide"
}, O = [
  ...t
], e = [!0, !1, "toggle"], i = {
  TOOLTIP_DIRECTIONS: I,
  TOOLTIP_DELAY_MS: T,
  TOOLTIP_KIND_MODIFIERS: _,
  TOOLTIP_STICKY_VALUES: O,
  TOOLTIP_HIDE_ON_CLICK_VARIANTS: e
};
export {
  T as TOOLTIP_DELAY_MS,
  I as TOOLTIP_DIRECTIONS,
  e as TOOLTIP_HIDE_ON_CLICK_VARIANTS,
  _ as TOOLTIP_KIND_MODIFIERS,
  O as TOOLTIP_STICKY_VALUES,
  i as default
};
//# sourceMappingURL=tooltip-constants.js.map
